exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".well > .label.label-warning  {background-color: #053c6d;}\r\n.dashboard_sec{\r\n    height: 100vh;\r\ntext-align: center;\r\n-ms-flex-line-pack: center;\r\n    align-content: center;\r\n-webkit-box-pack: center;\r\n    -ms-flex-pack: center;\r\n        justify-content: center;\r\ndisplay: inline;\r\n}\r\n.inner_content { font-size: 17px;text-align: left;padding-top: 15px;padding: 30px 65px;}\r\n.content-box{margin-bottom: 0;}\r\n.box-header.with-border {\r\n    height: 84vh;\r\n}\r\n@media (max-width: 1199px) {\r\n    .well h4 {\r\n      font-size: 14px; /* font size for screens with a maximum width of 1999px */\r\n    }\r\n}\r\n\r\n@media (max-width: 767px) {\r\n    .pull-right{\r\n        float: unset !important;\r\n    }\r\n}\r\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/xampp/htdocs/projects/angular.casherpay.stgnew/angular.casherpay/src/app/dashboard/dashboard.component.css
// module id = ../../../../../src/app/dashboard/dashboard.component.css
// module chunks = main